import {
	DASHBOARD_BLOG_ROUTE,
	DASHBOARD_ENQUIRY_ROUTE,
	DASHBOARD_LOAN_ROUTE,
	DASHBOARD_MEMO_ROUTE,
	DASHBOARD_NEWSLETTER_ROUTE,
	DASHBOARD_PROFILEROUTE,
	DASHBOARD_RE_APPLICANT_ROUTE,
	DASHBOARD_REPAYMENT_ROUTE,
	DASHBOARD_SETTINGS_ROUTE,
	DASHBOARD_STAFF_ROUTE,
	HOME_ROUTE
} from "routes"


export const menuData = [
	{
		icon: <i className="bi bi-house-fill text-xl"></i>,
		activeIcon: <i className="bi bi-house-fill text-xl"></i>,
		text: "Dashboard",
		isActive: false,
		link: HOME_ROUTE,
		roles: ["es", "lph", "fdo", "acc", "lo", "blog", "la"]
	},
	{
		icon: <i className="bi bi-person-fill-gear text-xl"></i>,
		activeIcon: <i className="bi bi-person-fill-gear text-xl"></i>,
		text: "Profile",
		isActive: false,
		link: DASHBOARD_PROFILEROUTE,
		roles: ["es", "lph", "fdo", "acc", "lo", "blog", "la"]
	},
	{
		icon: <i className="bi bi-wallet-fill text-xl"></i>,
		activeIcon: <i className="bi bi-wallet-fill text-xl"></i>,
		text: "Loans",
		isActive: false,
		link: DASHBOARD_LOAN_ROUTE,
		roles: ["es", "lph", "acc", "lo", "la"]
	},
	{
		icon: <i className="bi bi-wallet-fill text-xl"></i>,
		activeIcon: <i className="bi bi-wallet-fill text-xl"></i>,
		text: "Repayment History",
		isActive: false,
		link: DASHBOARD_REPAYMENT_ROUTE,
		roles: ["es", "lph", "acc", "lo", "la"]
	},
	{
		icon: <i className="bi bi-journal-text text-xl"></i>,
		activeIcon: <i className="bi bi-journal-text text-xl"></i>,
		text: "Memo",
		isActive: false,
		link: DASHBOARD_MEMO_ROUTE,
		roles: ["es", "lph", "la"]
	},
	{
		icon: <i className="bi bi-people-fill text-xl"></i>,
		activeIcon: <i className="bi bi-people-fill text-xl"></i>,
		text: "Staff",
		isActive: false,
		link: DASHBOARD_STAFF_ROUTE,
		roles: ["es"]
	},
	{
		icon: <i className="bi bi-ui-radios text-xl"></i>,
		activeIcon: <i className="bi bi-ui-radios text-xl"></i>,
		text: "Re-Applicant",
		isActive: false,
		link: DASHBOARD_RE_APPLICANT_ROUTE,
		roles: ["es", "lph", "lo", "la"]
	},
	{
		icon: <i className="bi bi-question-circle-fill"></i>,
		activeIcon: <i className="bi bi-question-circle-fill"></i>,
		text: "Enquiry",
		isActive: false,
		link: DASHBOARD_ENQUIRY_ROUTE,
		roles: ["fdo"]
	},
	{
		icon: <i className="bi bi-inbox-fill text-xl"></i>,
		activeIcon: <i className="bi bi-inbox-fill text-xl"></i>,
		text: "Newsletter",
		isActive: false,
		link: DASHBOARD_NEWSLETTER_ROUTE,
		roles: ["fdo"]
	},
	{
		icon: <i className="bi bi-gear-fill"></i>,
		activeIcon: <i className="bi bi-gear-fill"></i>,
		text: "Settings",
		isActive: false,
		link: DASHBOARD_SETTINGS_ROUTE,
		roles: ["es", "lph", "fdo", "acc", "lo", "blog", "la"]
	},
	{
		icon: <i className="bi bi-gear-fill"></i>,
		activeIcon: <i className="bi bi-gear-fill"></i>,
		text: "Blog",
		isActive: false,
		link: DASHBOARD_BLOG_ROUTE,
		roles: ["lph", "blog",]
	}
];


